import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	PrimaryGeneratedColumn,
} from 'typeorm';
import { AutomationTargetListEntity } from './automation-target-list.entity';
import { BaseEntity } from './base.entity';

@Entity('_automation_target_list_item')
export class AutomationTargetListItemEntity extends BaseEntity<string> {
	@PrimaryGeneratedColumn({ name: '_id', type: 'bigint', unsigned: true })
	declare id: string;

	@Column({
		name: '_fk__automation_target_list__id',
		type: 'int',
		unsigned: true,
	})
	public targetListId!: number;

	@Column({
		name: '_entity_id',
		type: 'varchar',
		length: 255,
		comment: 'The unique ID of the entity',
	})
	public entityId!: string;

	@Column({
		name: '_entity_data',
		type: 'json',
		comment: 'Full entity data as JSON',
	})
	public entityData!: Record<string, any>;

	@Column({
		name: '_excluded',
		type: 'boolean',
		default: false,
		comment: 'Whether this item is excluded from processing',
	})
	public excluded!: boolean;

	@ManyToOne(() => AutomationTargetListEntity, (list) => list.items)
	@JoinColumn({ name: '_fk__automation_target_list__id' })
	public targetList!: AutomationTargetListEntity;

	@Index('uk_list_entity', { unique: true })
	public static uniqueIndex: [string, string] = ['targetListId', 'entityId'];

	@Index('idx_automation_target_list_item_list')
	public static listIndex: [string] = ['targetListId'];

	@Index('idx_automation_target_list_item_excluded')
	public static excludedIndex: [string] = ['excluded'];
}
